import React from 'react';
import { Link } from 'react-router-dom';
import { FaStar } from 'react-icons/fa';
import { MdDoubleArrow } from 'react-icons/md';
import { CompanyName, UPWORK_URL } from '../../utils/Constants';

function ReviewsShortSection() {
  const reviews = [
    {
      project: 'UGC video Norway',
      rating: 5,
      date: 'Feb 4, 2025 – Aug 29, 2025',
      feedback:
        'Thank you for the high-quality work! The video fully meets my expectations. Communication was smooth, and the freelancer had a clear understanding of the task from the very beginning.',
      price: '$800.00',
      type: 'UGC videos',
    },
    {
      project: 'UGC video production',
      rating: 5,
      date: 'Feb 3, 2025 – Jun 4, 2025',
      feedback:
        'Siv made an amazing content for me! Communication and working skills at the highest level! I recommend everyone to work with her!',
      price: '$450.00',
      type: 'UGC video production',
    },
    {
      project: 'UGC video production',
      rating: 5,
      date: 'Oct 7, 2024 – Nov 26, 2024',
      feedback: '',
      price: '$75.00',
      type: 'UGC video production',
    },
    {
      project: 'UGC video production',
      rating: 5,
      date: 'Sep 13, 2024 – Sep 25, 2024',
      feedback:
        'Absolutely thrilled with the UGC video you created! Your enthusiasm and energy were infectious, making it a joy to watch. Fantastic work!',
      price: '$50.00',
      type: 'UGC video production',
    },
    {
      project: 'UGC video production',
      rating: 5,
      date: 'Aug 20, 2024 – Sep 25, 2024',
      feedback: 'Everything is great :) Thanks :)',
      price: '$120.00',
      type: 'UGC video production',
    },
    {
      project: '2 Norwegian video!)',
      rating: 5,
      date: 'Aug 23, 2024 – Sep 18, 2024',
      feedback:
        'Siv Renate did an AMAZING job on my UGC video!😊 Great work! Thank you for the fast delivery and high-quality video! Recommend to everyone!',
      price: '$90.00',
      type: 'UGC video production',
    },
  ];

  return (
    <section className='grid gap-y-8 px-8 py-8 xl:py-24 2xl:px-32 lg:px-16'>
      <div className='grid gap-y-4 lg:gap-y-6'>
        <h3 className='font-titleFont text-2xl text-center underline underline-offset-8'>
          CLIENT REVIEWS
        </h3>
        <h4 className='text-center lg:text-xl italic font-serif'>
          Trusted by brands, delivered by {CompanyName}
        </h4>
      </div>

      {/* Reviews grid */}
      <div className='grid lg:grid-cols-3 gap-6'>
        {reviews.map((review, index) => (
          <article
            key={index}
            className='grid gap-3 bg-coloour1 rounded-3xl shadow-md p-6 text-center'
          >
            <div className='grid gap-1'>
              <h5 className='text-lg font-semibold'>{review.project}</h5>
              <span className='text-sm italic text-colour5 opacity-80'>
                {review.date}
              </span>
            </div>

            {/* Rating */}
            <div className='flex justify-center gap-1'>
              {Array.from({ length: review.rating }).map((_, i) => (
                <FaStar key={i} className='text-yellow-500' />
              ))}
            </div>

            {/* Feedback */}
            {review.feedback && (
              <p className='text-sm opacity-90'>
                &ldquo;{review.feedback}&rdquo;
              </p>
            )}

            {/* Price + Type */}
            <div className='grid text-sm font-semibold mt-2'>
              <span className='text-xs opacity-70'>{review.type}</span>
            </div>
          </article>
        ))}
      </div>

      {/* CTA: View on Upwork */}
      <div className='grid px-0 justify-center'>
        <a
          href={UPWORK_URL}
          target='_blank'
          rel='noopener noreferrer'
          className='grid text-xl md:text-sm w-full p-1 bg-colour5 text-colour1 shadow-lg font-semibold font-poppins hover:brightness-90 duration-200 h-fit'
          aria-label='View reviews on Upwork'
        >
          <div className='grid grid-cols-rev items-center border-[1px] border-colour1 border-solid gap-x-8 py-1 px-4 lg:py-2 lg:px-8'>
            <span> VIEW ON UPWORK</span>
            <MdDoubleArrow className='text-xl lg:text-2xl' />
          </div>
        </a>
      </div>
    </section>
  );
}

export default ReviewsShortSection;
